import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/download/69c0e7967d947e00146843ba/showcrm/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69c0e7967d947e00146843ba/showcrm/src/styles/tailwind.css");
